import { Chain, createClient, http, webSocket } from "viem";
import { mainnet } from "viem/chains";
import { createConfig } from "wagmi";

const supportedChains: [Chain, ...Chain[]] = [mainnet];

export const wsConfig = createConfig({
  chains: supportedChains,
  client: ({ chain }) => {
    return createClient({
      chain,
      transport: webSocket(
        "wss://virtual.mainnet.eu.rpc.tenderly.co/6f7a485d-1619-436d-85d6-f39d8c6e4a91"
      ),
    });
  },
});

export const config = createConfig({
  chains: supportedChains,
  client: ({ chain }) => {
    return createClient({
      batch: {
        multicall: {
          batchSize: 1024 * 3, // 3kb
        },
      },
      chain,
      transport: http(
        "https://virtual.mainnet.eu.rpc.tenderly.co/515bd3d0-634d-4a03-8091-88e7afa5eea9"
      ),
    });
  },
});
